module.exports = __webpack_public_path__ + "img/logo_arrastre.8b5d253c.png";